import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';

const apiUrl = '/api/v1';

const baseOptions: AxiosRequestConfig = {
  baseURL: apiUrl,
  timeout: 15000,
  headers: {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
    'X-Web-Request': 'true',
  },
};

export type HttpClientResolver = () => Promise<AxiosInstance>;

export default () => Promise.resolve(axios.create(baseOptions));
